import React, { useEffect } from 'react';
import { NotificationGroup, Notification } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';
import { GearNotificationType } from '../../Model/enums/GearNotificationType';

const DEFAULT_TIMEOUT = 6000;

export interface GearNotificationProps {
  show: boolean;
  type: GearNotificationType;
  message: string;
  timeout?: number;
  onClose?: () => void;
}

export const GearNotification: React.FC<GearNotificationProps> = props => {
  useEffect(() => {
    if (!props.show) {
      return;
    }

    const timer = setTimeout(() => {
      if (props.onClose) {
        props.onClose();
      }
    }, props.timeout ?? DEFAULT_TIMEOUT);

    return () => clearTimeout(timer);
  }, [props.show, props.onClose, props.timeout, props]);

  return (
    <NotificationGroup className={'gearNotification'}>
      <Fade enter={true} exit={true}>
        {props.show && (
          <Notification type={{ style: props.type, icon: true }} closable={true} onClose={props.onClose}>
            <span>{props.message}</span>
          </Notification>
        )}
      </Fade>
    </NotificationGroup>
  );
};
